<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-10 mr-auto">
        <h3>Keyword Message Consol</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row mb-3 text-center">
      <table class="table table-striped table-bordered mt-3" style="width:100%" >
        <thead>
          <th>ID</th>
          <th>Source</th>
          <th>ShortCode</th>
          <th>Keyword</th>
          <th>Operator</th>
        </thead>
        <tbody>
          <td>{{keyword.id}}</td>
          <td>{{keyword.sourceView}}</td>
          <td>{{keyword.shortCode}}</td>
          <td>{{keyword.keyword}}</td>
          <td>{{keyword.operator}}</td>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-10 align-self-center">
    Total Results: {{totalItems}} &nbsp;&nbsp;
    <i class="fas fa-question-circle" placement="top"></i> &nbsp;<a target="_blank" [routerLink]="['/dashboard/support/msg-template']">View template field description</a>
  </div>
  <div class="col-2 ml-auto text-right">
    <button class="btn btn-default btn-sm mr-2" (click)="openModal(newMsgModel)">+ New Template</button>
    <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
    <button class="btn btn-default btn-sm mr-2" (click)="back()">Back</button>
  </div>
</div>
<!-- <div class="table-responsive"> -->
<table id="metaList" class="table table-striped table-bordered mt-3" style="width:100%">
  <thead class="text-center">
    <th>Language</th>
    <th>Messages</th>
    <th>Operate</th>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="3">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="3">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let msg of msgList; index as i;">
      <td class="text-center align-middle">{{msg.lang}}</td>
      <td>
        <table class="table table-striped" style="width:100%" >
          <tr>
            <th>Sub Success</th><td>{{msg.subscribeSuccessMsg}}</td><th>Already Sub</th><td>{{msg.subscribeAlreadyMsg}}</td>
          </tr>
          <tr>
            <th>Sub Failed</th><td>{{msg.subscribeFailedMsg}}</td><th>Sub Failed with Low Balance</th><td>{{msg.subscribeLowBalanceMsg}}</td>
          </tr>
          <tr>
            <th>Sub Success with charge</th><td>{{msg.subscribeChargeSuccessMsg}}</td><th>Sub Success url with charge</th><td>{{msg.subscribeChargeSuccessUrl}}</td>
          </tr>
          <tr>
            <th>Renewal Success</th><td>{{msg.renewalSuccessMsg}}</td><th>Renewal Success URL</th><td>{{msg.renewalSuccessUrl}}</td>
          </tr>
          <tr>
            <th>Renewal Reminder</th><td>{{msg.renewalReminderMsg}}</td><th>Renewal Failed with Low Balance</th><td>{{msg.renewalLowBalanceMsg}}</td>
          </tr>
          <tr>
            <th>Unsub Success</th><td>{{msg.unsubscribeSuccessMsg}}</td><th>Unsub Already</th><td>{{msg.unsubscribeAlreadyMsg}}</td>
          </tr>
          <tr>
            <th>MT Content</th><td>{{msg.mtContent}}</td><th>MT content URL</th><td>{{msg.mtContentUrl}}</td>
          </tr>
        </table>
      </td>
      <td class="text-center align-middle">
        <a type="button" class="btn btn-sm btn-primary mr-2 mt-2" placement="top" ngbTooltip="View & Edit" [routerLink]="['/dashboard/tx/kw-msg-detail', msg.id]" >
          <i class="fas fa-pen"></i>
        </a>
        <button type="button" class="btn btn-sm btn-danger mr-2 mt-2" placement="top" ngbTooltip="Delete" (click)="deleteMsg(msg.id)">
          <i class="fas fa-trash"></i>
        </button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="3" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
        <!-- <button (click)="setPage(2)">GO TO PAGE</button> -->
      </td>
    </tr>
  </tfoot>
</table>
<!-- </div> -->

<ng-template #newMsgModel let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="newMsgLabel">New Template</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" id="newMeta-modal-body">
    <form [formGroup]="newMsgForm" (ngSubmit)="onSubmit()">
      <small><i class="text-danger">* indicates mandatory field</i> &nbsp;
        <i class="fas fa-question-circle" placement="top"></i> &nbsp;<a target="_blank" [routerLink]="['/dashboard/support/msg-template']">View template field description</a>
      </small>
      <div class="form-group row p-2">
        <div class="col-sm-12">
          <label for="lang" class="col-form-label"><span class="text-danger">* </span>Language:</label>
          <input type="text" class="form-control" formControlName="lang">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.lang.errors">
                Language cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <label for="subscribeSuccessMsg" class="col-form-label">Sub Success:</label>
          <input type="text" class="form-control" formControlName="subscribeSuccessMsg">
        </div>
        <div class="col-sm-12">
          <label for="subscribeAlreadyMsg" class="col-form-label">Sub Already:</label>
          <input type="text" class="form-control" formControlName="subscribeAlreadyMsg">
        </div>
        <div class="col-sm-12">
          <label for="subscribeFailedMsg" class="col-form-label">Sub Failed:</label>
          <input type="text" class="form-control" formControlName="subscribeFailedMsg">
        </div>
        <div class="col-sm-12">
          <label for="subscribeChargeSuccessMsg" class="col-form-label">Sub Success With Charge:</label>
          <input type="text" class="form-control" formControlName="subscribeChargeSuccessMsg">
        </div>
        <div class="col-sm-12">
          <label for="subscribeChargeSuccessUrl" class="col-form-label">Sub Success URL With Charge:</label>
          <input type="text" class="form-control" formControlName="subscribeChargeSuccessUrl">
        </div>
        <div class="col-sm-12">
          <label for="subscribeLowBalanceMsg" class="col-form-label">Sub Failed With Low Balance:</label>
          <input type="text" class="form-control" formControlName="subscribeLowBalanceMsg">
        </div>
        <div class="col-sm-12">
          <label for="renewalReminderMsg" class="col-form-label">Renewal Reminder:</label>
          <input type="text" class="form-control" formControlName="renewalReminderMsg">
        </div>
        <div class="col-sm-12">
          <label for="renewalSuccessMsg" class="col-form-label">Renewal Success:</label>
          <input type="text" class="form-control" formControlName="renewalSuccessMsg">
        </div>
        <div class="col-sm-12">
          <label for="renewalSuccessUrl" class="col-form-label">Renewal Success URL:</label>
          <input type="text" class="form-control" formControlName="renewalSuccessUrl">
        </div>
        <div class="col-sm-12">
          <label for="renewalLowBalanceMsg" class="col-form-label">Renewal Failed With Low Balance:</label>
          <input type="text" class="form-control" formControlName="renewalLowBalanceMsg">
        </div>
        <div class="col-sm-12">
          <label for="unsubscribeSuccessMsg" class="col-form-label">Unsub Success:</label>
          <input type="text" class="form-control" formControlName="unsubscribeSuccessMsg">
        </div>
        <div class="col-sm-12">
          <label for="unsubscribeAlreadyMsg" class="col-form-label">Unsub Already:</label>
          <input type="text" class="form-control" formControlName="unsubscribeAlreadyMsg">
        </div>
        <div class="col-sm-12">
          <label for="mtContent" class="col-form-label">MT Content:</label>
          <input type="text" class="form-control" formControlName="mtContent">
        </div>
        <div class="col-sm-12">
          <label for="mtContentUrl" class="col-form-label">MT Content URL:</label>
          <input type="text" class="form-control" formControlName="mtContentUrl">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
        <button type="submit" class="btn btn-primary" *ngIf="!processing">Add</button>
        <button type="submit" class="btn btn-primary" *ngIf="processing" disabled>Processing..</button>
      </div>
    </form>
  </div>
</ng-template>
